export default __webpack_public_path__ + "static/media/rack-tshirt.b51fc068.png";